import { Group, Skeleton, Stack, Text } from '@mantine/core';
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getTopMission } from '../../services/report-gamification';
import DataTables from '../../components/elements/DataTables';
import Card from '../../components/elements/Card';
import { defaultSizeTable } from '../../components/elements/DataTables/DataTables';

export default function TopMission() {
  const column = [
    {
      heading: 'Mission Name',
      props: (item) => (
        <Text className="text-xs-medium">{item.missionName || 'Unknown'}</Text>
      ),
      id: 'missionName',
      sortable: true
    },
    {
      heading: 'Activity',
      props: (item) => (
        <Text className="text-xs-medium">{item.totalActive}x Active</Text>
      ),
      id: 'totalActive',
      sortable: true
    }
  ];

  const fetchedDataFrequencyMission = useQuery({
    queryKey: [`topFrequencyMission`],
    queryFn: () => getTopMission(),
    enabled: true
  });

  const { data: dataFrequencyMission, isLoading } = fetchedDataFrequencyMission;

  return (
    <Card flex={1} h={'100%'}>
      <Stack gap={'xs'}>
        <Group justify="space-between">
          <Text className="text-sm-semibold">Top Frequent Mission</Text>
          <Text className="text-xs-medium" c="gray">
            Last 30 days
          </Text>
        </Group>
        {isLoading && <Skeleton height={150} />}

        {!isLoading && (
          <DataTables
            columns={column}
            loading={false}
            data={dataFrequencyMission?.data?.data}
            sizing={[
              { label: '3', value: 3 },
              { label: '5', value: 5 },
              ...defaultSizeTable
            ]}
            activeSize={3}
          />
        )}
      </Stack>
    </Card>
  );
}
